export default __webpack_public_path__ + "static/media/slider-img5.6930e195.png";